import { useState } from "react";
import { useMembers } from "../../hooks/useMembers";
import Card from "../../components/ui/Card";
import Badge from "../../components/ui/Badge";
import Avatar from "../../components/ui/Avatar";
import Input from "../../components/ui/Input";

const fmt = (n: number) =>
  new Intl.NumberFormat("en-NG", { style: "currency", currency: "NGN", currencyDisplay: "symbol", maximumFractionDigits: 0 }).format(n);
const fmtDate = (d: string) =>
  d ? new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—";

export default function MembersPage() {
  const [search, setSearch] = useState("");
  const { data: members = [], isLoading } = useMembers(search) as any;

  return (
    <div>
      <div className="mb-5">
        <Input label="" value={search} onChange={setSearch} placeholder="🔍 Search members by name or email…"/>
      </div>
      {isLoading ? (
        <p className="text-sm text-slate-400 text-center py-10">Loading members…</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {(members as any[]).map((m: any) => (
            <Card key={m.id}>
              <div className="flex gap-3 items-center mb-3">
                <Avatar initials={`${m.first_name?.[0]}${m.last_name?.[0]}`} size={40}/>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-slate-800 truncate">{m.first_name} {m.last_name}</p>
                  <p className="text-xs text-slate-400 truncate">{m.email}</p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-2 mb-3">
                <div className="bg-emerald-50 rounded-lg p-2.5">
                  <p className="text-[10px] text-emerald-700 mb-0.5">Balance</p>
                  <p className="text-sm font-medium text-emerald-800">{fmt(m.balance ?? 0)}</p>
                </div>
                <div className="bg-slate-50 rounded-lg p-2.5">
                  <p className="text-[10px] text-slate-500 mb-0.5">Joined</p>
                  <p className="text-xs text-slate-700">{fmtDate(m.created_at)}</p>
                </div>
              </div>
              <Badge label="✅ Active member" color="emerald"/>
            </Card>
          ))}
          {(members as any[]).length === 0 && (
            <div className="col-span-3 text-center py-10 text-sm text-slate-400">No members found</div>
          )}
        </div>
      )}
    </div>
  );
}
